<template>
    <div style="overflow: hidden;width: 100%">
        <CommonHeader/>
        <div class="container" style="min-height: calc(100vh - 56px - 88px);">
            <a-row>
                <a-col class="mt-3 mb-3" :span="24">
                    <a-breadcrumb>
                        <a-breadcrumb-item><a href="">首页</a></a-breadcrumb-item>
                        <a-breadcrumb-item>资格审查文件上传</a-breadcrumb-item>
                    </a-breadcrumb>
                </a-col>
            </a-row>
            <page-header-wrapper>
                <a-card>
                    <a-form :form="form" class="custom pick-100 form-input about">
                        <a-row>
                            <a-col :span="24">
                                <a-divider class="color-orange mt-6" orientation="left">项目信息</a-divider>
                            </a-col>
                            <table style="width:100%" class="fx-form">
                                <tr>
                                    <th>项目名称:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['supplierName',{initialValue:project.xmmc}]"
                                            />
                                        </a-form-item>
                                    </td>
                                    <th>项目编号:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['xmbh',{initialValue:project.wbbh?project.wbbh:project.xmbh}]"
                                            />
                                        </a-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <th>采购人单位:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['cgrmc',{initialValue:project.cgrmc}]"
                                            />
                                        </a-form-item>
                                    </td>
                                    <th>报名截止时间:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: red;font-weight: bold"
                                                    disabled
                                                    v-model="project.bmjzsj"></a-input>
                                        </a-form-item>
                                    </td>
                                </tr>
                            </table>
                        </a-row>
                        <a-row>
                            <a-col :span="24">
                                <a-divider class="color-orange mt-6" orientation="left">供应商信息</a-divider>
                            </a-col>
                            <table style="width:100%" class="fx-form">
                                <tr>
                                    <th>供应商名称:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['supplierName',{initialValue:supplier.supplierName}]"
                                            />
                                        </a-form-item>
                                    </td>
                                    <th>
                                        <span v-if="supplier.supplierType === '2'">统一社会信用代码:</span>
                                        <span v-else-if="supplier.supplierType === '1' && supplier.natureType === '2'">注册号:</span>
                                        <span v-else-if="supplier.supplierType === '1' && supplier.natureType === '1'">身份证号:</span>
                                    </th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    v-if="supplier.supplierType === '2'"
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['supplierCode',{initialValue:supplier.supplierCode}]"
                                            />
                                            <a-input
                                                    v-if="supplier.supplierType === '1'"
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['supplierCode',{initialValue:supplier.legalIdCard}]"
                                            />
                                        </a-form-item>
                                    </td>
                                </tr>
                            </table>
                        </a-row>
                        <a-row v-if="bidZgys && bidZgys.checkStatus === '2' ">
                            <a-col :span="24">
                                <a-divider class="color-orange mt-6" orientation="left">资格审查意见</a-divider>
                            </a-col>
                            <table style="width:100%" class="fx-form">
                                <tr>
                                    <th colspan="3" style="text-align: left;padding-left: 65px">
                                        <a-form-item>
                                            您提交的资格审查文件审核不通过，请修改后重新上传。
                                        </a-form-item>
                                    </th>
                                    <td >

                                    </td>
                                </tr>
                                <tr>
                                    <th>审查意见:</th>
                                    <td>
                                        <a-form-item>
                                            <span style="color: red">{{bidZgys.rollbackReason}}</span>
                                        </a-form-item>
                                    </td>

                                </tr>
                            </table>
                        </a-row>
                        <a-row>
                            <a-col :span="24">
                                <a-divider class="color-orange mt-6" orientation="left">资格审查文件上传</a-divider>
                            </a-col>
                            <table style="width:100%" class="fx-form">

                                <tr>
                                    <th class="not-null">资格预审文件:</th>
                                    <td>
                                        <a-form-item>
                                            <upload-selector :referId='projectIdAndsupplierId' :max="1" ref="selector1"
                                                             :readonly="bidZgys && bidZgys.commitStatus==='1'?'readonly':false"
                                                             configKey='BID_ZGYS_FILE'/>
                                        </a-form-item>
                                    </td>
                                </tr>
                            </table>
                        </a-row>
                        <a-row class="mt-6">
                            <a-col :span="6" :offset="9">
                                <a-button class="mt-4" type="primary"
                                          :disabled="bidZgys &&  bidZgys.commitStatus==='1'?true:false"
                                          @click="onSubmitCheck">{{bidZgys &&
                                    bidZgys.commitStatus==='1'?'已提交审核':'提交审核'}}
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-card>
            </page-header-wrapper>
        </div>
        <CommonFooter/>
    </div>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import {PageView} from '@/layouts'
    import STable from '@/components/Table'
    import moment from 'moment'
    import 'vue-area-linkage/dist/index.css'
    import UploadSelector from "../../components/selector/UploadSelector";
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from "../common/CommonFooter";

    export default {
        created() {
            this.loadData()
        },
        components: {
            PageView,
            STable,
            moment,
            UploadSelector,
            CommonFooter,
            CommonHeader
        },
        name: 'ZgYsFile',
        data() {
            return {
                projectId: this.$route.query.projectId,
                bidZgys: {},
                form: this.$form.createForm(this),
                supplier: {},
                project: {},
                projectIdAndsupplierId:''
            }
        },
        methods: {
            loadData() {
                if (!this.projectId) {
                    this.error("项目ID数据异常!")
                    return;
                }
                let url = '/api/v1/supplier/legalsign/getLegalProjectDetails.json?projectId=' + this.projectId
                this.$http.get(url).then(res => {
                    this.supplier = res.supplier
                    this.projectIdAndsupplierId = this.projectId+res.supplier.id
                    this.account = res.account
                    this.project = res.project
                    this.project.bmjzsj=this.project.bmjzsj?this.project.bmjzsj.substring(0,this.project.bmjzsj.length-3):''
                    this.bidZgys = res.bidZgys
                })
            },
            error(val) {
                this.$error({
                    title: '提示',
                    content: val
                })
            },
            onSubmitCheck() {
                let that = this
                if (that.$refs.selector1.uploadFiles.length === 0) {
                    that.$error({
                        title: '提示',
                        content: '请先上传资格预审文件！！！'
                    })
                    return
                }
                that.$confirm({
                    title: '提交审核',
                    content: '是否确认提交资格预审文件进行审核？提交后不可进行修改！！！',
                    onOk() {
                        let url = '/api/v1/supplier/legalsign/onSubmitCheck.json?xmid=' + that.projectId+'&commitType=zgys'
                        that.$http.get(url).then(res => {
                            if (res.code !== 200) {
                                that.$message.error("提交失败")
                                return
                            }
                            that.bidZgys = res.result
                            that.$message.success("提交审核成功")
                            that.$router.push({path:'/index?activeKey=4'})
                        })
                    }, onCancel() {
                        console.log("点击了取消")
                    }
                })

            },
            checkYqgys() {
                let that = this
                if ('13' === that.project.cgfs && '1' === that.project.xyzgys) {
                    if (that.$refs.selector1.uploadFiles.length === 0) {
                        that.$error({
                            title: '提示',
                            content: '请先上传资格预审文件！！！'
                        })
                        return
                    } else {
                        let content = "请先提交资格预审文件进行审核，审核通过后即可进行报名！！！"
                        if (that.bidZgys.commitStatus === '0') {
                            that.error(content)
                            return

                        } else if (that.bidZgys.commitStatus === '2') {
                            content = "资格预审文件审核不通过，请重新提交资格预审文件进行审核！！！"
                            that.error(content)
                            return
                        }

                    }
                    let url = '/api/v1/supplier/legalsign/checkYqGys.json?xmid=' + that.projectId
                    that.$http.get(url).then(res => {
                        if (res.code !== 200) {
                            that.$message.error("报名失败")
                            return
                        }
                        console.log(res)
                        that.bidZgys.checkStatus = res.result.checkStatus
                        if ('1' === res.result.checkStatus) {
                            that.onSubmit()
                        } else {
                            that.$warning({
                                title: '提示',
                                content: res.msg
                            })
                        }
                    })
                } else {

                }
            },

        }
    }
</script>

<style lang="less" scoped>
    .step-form-style-desc {
        padding: 0 56px;
        color: rgba(0, 0, 0, .45);

        h3 {
            margin: 0 0 12px;
            color: rgba(0, 0, 0, .45);
            font-size: 16px;
            line-height: 32px;
        }

        h4 {
            margin: 0 0 4px;
            color: rgba(0, 0, 0, .45);
            font-size: 14px;
            line-height: 22px;
        }

        p {
            margin-top: 0;
            margin-bottom: 12px;
            line-height: 22px;
        }
    }

    /deep/ .ant-form-item-label label {
        color: #8c8c8c;
    }

    /deep/ .ant-form-item-children {
        color: #000;
        font-weight: bold;
    }

    .register-title {
        position: relative;
    }

    .register-title img {
        margin: auto;
    }

    .register-title p {
        position: absolute;
        top: 10px;
        font-size: 20px;
        color: #fff;
        width: 100%;
        text-align: center;
    }

    .ant-input {
        width: 100%;
    }

    th {
        width: 125px;
    }

    tr {
        height: 65px;
    }

    .ant-table-thead > tr > th {
        font-weight: bold;
    }
</style>
